'use strict';
import * as _ from 'underscore';
App.Views.SystemExportTTNotification = App.Views.SystemExportNotification.extend({
    
    getActions: function () {
        var done = '';
        var status = '<br>Status: ' + this.getLabel();
        if (this.model.get('process') == 'done') {
            done = '_done';
            status = '';
        }
        return _.extend(
            App.Views.SystemExportNotification.prototype.getActions.call(this),
            {
                action: Messages.getText('noty.system_export-tt' + done + '.action'),
                bodyRaw: Messages.getText('noty.system_export-tt' + done + '.body') + status,
                body: App.Helpers.MarkdownHelper.stripTags(Messages.getText('noty.system_export-tt' + done + '.body'))
            }
        )
    },

    getLabel: function() {
        return this.model.get('label') || 'preparation';
    }
});
